import type { FrameCaptureSources } from './resolveFrameCapturePlan';
import type { QuoteFrameSource } from './types';

/**
 * The frame source actually used for NEW automatic frames and shown on the
 * carousel-wide toggle: a stored 'edited' falls back to 'original' while the
 * edited render is unavailable (no export, or expired). The stored value and
 * existing slides are not rewritten.
 */
export function resolveEffectiveFrameSource(
  frameSource: QuoteFrameSource,
  sources: FrameCaptureSources,
): QuoteFrameSource {
  return frameSource === 'edited' && !sources.edited ? 'original' : frameSource;
}
